import { Component, inject } from '@angular/core';
import { NewsLetterService } from '../Services/newsLetter.service';
import { NewsLetterModel } from '../Model/newsLetter.model';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-newsletter',
    imports: [ReactiveFormsModule, FormsModule, TranslateModule, ToasterComponent, CommonModule],
    templateUrl: './newsletter.component.html',
    styleUrl: './newsletter.component.css'
})
export class NewsletterComponent {
    email: string = '';
    showToast = false;
    toastMessage = '';
    toastType: 'success' | 'error' = 'success';
    private subs = new Subscription();   // container for all subscriptions

    private newsLetterService = inject(NewsLetterService);
    private translate = inject(TranslateService)

    onSubmit(form: any) {
        if (form.valid) {
            const messageData: NewsLetterModel = {
                email: this.email
            };

            const sub = this.newsLetterService.createMessage(messageData).subscribe({
                next: () => {
                    this.toastType = 'success';
                    this.toastMessage = this.translate.instant('NEWSLETTER.SUCCESS');
                    this.showToast = true;
                    form.reset();
                    setTimeout(() => this.showToast = false, 3000);
                },
                error: () => {
                    this.toastType = 'error';
                    this.toastMessage = this.translate.instant('NEWSLETTER.ERROR');
                    this.showToast = true;
                    setTimeout(() => this.showToast = false, 3000);
                }
            });
            this.subs.add(sub);
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();   // unsubscribe from all
    }
}